import {
    validatorParentescoEmDuplicidade,
    retornaLabelDoValorParentesco,
    idadeAte65,
    idadeAcima65,
    validarLimiteCategoria,
    validarCategoria
} from './funcoesAuxiliaresZB';

export class CorrenteEdicaoZB {
    constructor(dependentes, parentesco, categorias, valoresForm, isValid) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.isValid = isValid;
        this.categoriaSelecionada = valoresForm.Categoria;
        this.qtdDependentes = this.dependentes.length;
    }

    verificarMudancaCategoria() {
        if (this.isValid.Categoria !== this.categoriaSelecionada) {
            return this.validarCategoriasPlano();
        }

        return this;
    }

    validarCategoriasPlano() {
        switch (this.valoresForm.Categoria.trim()) {
            case 'ZELO':
                if (!validarLimiteCategoria(this.dependentes, 'ZELO', 2)) {
                    this.arrayMsgsErro.push('O máximo de dependentes sem valor adicional são dois dependentes.');
                }

                break;
            case 'ZTA64':
                if (!validarLimiteCategoria(this.dependentes, 'ZTA64', 1)) {
                    this.arrayMsgsErro.push('Para este plano só pode ser inserido um dependente especial.');
                }

                break;
            case 'ZTM65':
                if (!validarLimiteCategoria(this.dependentes, 'ZTM65', 1)) {
                    this.arrayMsgsErro.push('O máximo de dependentes da categoria ZELO MAIOR 65 ANOS é um dependente.');
                }

                break;
        }

        if (this.valoresForm.Categoria && this.valoresForm.Categoria !== 'ZELO') {
            if (!validarCategoria(this.dependentes, this.valoresForm.Categoria)) {
                this.arrayMsgsErro.push('Para este plano só pode ser inserido um dependente especial.');
            }
        }

        return this;
    }

    parentescoEpecialComAdicionalAte65() {
        if (this.valoresForm.Idade && idadeAte65(this.valoresForm.Idade)) {
            if (this.valoresForm.Categoria && this.valoresForm.Categoria === 'ZTM65') {
                this.arrayMsgsErro.push('A categoria selecionada não corresponde a idade do dependente.');
            }
        }

        return this;
    }

    parentescoEspecialComAdicionalMaior65() {
        if (this.valoresForm.Idade && idadeAcima65(this.valoresForm.Idade)) {
            if (this.valoresForm.Categoria && this.valoresForm.Categoria === 'ZTA64') {
                this.arrayMsgsErro.push('A categoria selecionada não corresponde a idade do dependente.');
            }
        }

        return this;
    }

    parentescoEmDuplicidade() {
        if (validatorParentescoEmDuplicidade(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro = [`${retornaLabelDoValorParentesco(this.parentesco)}`];
        }

        return this;
    }
}
